export default "__VITE_ASSET__GthapyLO__"